module.exports = __webpack_public_path__ + "static/media/pkm-brt2.19dc3e40.jpg";